import { useCallback } from 'react'
import { postSubmit } from '@ui-seeker/utils'
import { BACKEND_APIS } from '@constants'
import { MAPPING_TYPE } from 'Pages/Admin/AdminMapping/@constants'
import { acrissTable, categoriesTable } from 'Pages/Admin/AdminMapping/@signals'
import { useToast } from '@hooks'
import { useSignal } from '@preact/signals-react'

export default function useAdminMappingUpdate() {

	const { showToast } = useToast()
	const isLoadingDelete = useSignal(false)

	const handleDeleteMapping = useCallback((idCustom, path) => {
		showToast.confirm(`Are you sure to delete this mapping?`, {
			onSubmit: () => {
				isLoadingDelete.value = true
				showToast.promise(postSubmit(`${path === MAPPING_TYPE.ACRISS ? BACKEND_APIS.CUSTOM_ACRISS : BACKEND_APIS.CUSTOM_CATEGORY}/disable`,
					{ idCustom: idCustom }),
				).then(() => {
					if (path === MAPPING_TYPE.ACRISS) {
						acrissTable.value = [...acrissTable.value?.filter(e => idCustom !== e.idCustom)]
					} else {
						categoriesTable.value = [...categoriesTable.value?.filter(e => idCustom !== e.idCustom)]
					}
				}).catch(() => {
					showToast.error()
				}).finally(() => {
					isLoadingDelete.value = false
				})
			}
		})
	}, [])


	return {
		handleDeleteMapping,
		isLoadingDelete: isLoadingDelete.value
	}
}